import $ from 'jquery';
import Popin from './generic/popin';
import SessionStoragePop from './generic/SessionStoragePop';
import {updateLoginBoxNamesLhs} from '../name';
import {MARKET} from 'Utils/market.constants';

export const POPIN_PROFILE_DEFAULT_VALUES = {
    MOBILE_BREAKPOINT : 768,
    TEXT_HEADLINE: "Sécurité",
    //TEXT_DESCRIPTION_1: "Bienvenue ",
    //TEXT_DESCRIPTION_2: ", Vous naviguez désormais sur votre espace ",
    //TEXT_DESCRIPTION_3: ". Attention à vos identifiants utilisés.",
    TEXT_DESCRIPTION_1: "<p>Bienvenue sur votre espace client ",
    TEXT_DESCRIPTION_2: ".</p><p>Attention : veillez à bien utiliser ",
    TEXT_DESCRIPTION_3: "votre code secret  ",
    TEXT_DESCRIPTION_4: " pour toute opération les nécessitant.</p>",
    SESSION_STORAGE_POPIN_ACTIVATED: "popin_activate_nav_pro_pri",
    APP: "NavProPri",
    PRIORITY_MOBILE: 1
}

export default class PopinNavProPriApp {

    constructor() {
        var _self = this;

        // init default values
        _self.sessionKey = POPIN_PROFILE_DEFAULT_VALUES.SESSION_STORAGE_POPIN_ACTIVATED;
        _self.initMobileContext();

        // Init session storage with custom key
        _self.sessionStoragePop = new SessionStoragePop(_self.sessionKey);
        // Do not display popin if yet closed during session
        // So do not check the cookie in this context

        _self.needToDisplayPopin = false;
        _self.clientName = updateLoginBoxNamesLhs();
        _self.currentApp = POPIN_PROFILE_DEFAULT_VALUES.APP;

        _self.market = "Particuliers";
        if(MARKET.CODE === 2){
            _self.market = "Professionnels"
        }

        //Si on a le flag true dans le local storage ça signifie que la popin a déjà été affiché au cours de la session donc on n'affiche pas la popin
        //Si on ne l'a pas on vérifie que l'on est dans le cas du parcours nav pro pri et si oui on affiche la popin
        if (_self.sessionStoragePop.getJsonObjectFromSession()) {
            _self.needToDisplayPopin = false;
        }else if (sasJs !== undefined && sasJs["user-auth-origin"] !== undefined && (sasJs["user-auth-origin"] === "PRI" || sasJs["user-auth-origin"] === "PRO")){
            _self.needToDisplayPopin = true;
        }

        _self.popin = new Popin(null, _self.currentApp, _self.priorityMobile, false);

        // Event when first element closed
        window.EventBusCMS.addEventListener('popinGenericEventOnClose', event => {
            if (event.detail.currentApp === _self.currentApp) {
                _self.sessionStoragePop.addSimpleBooleanInSessionStorage();
            }
        });

    }

    initMobileContext() {
        // Init Mobile context
        this.onMobile = false;
        if ($(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            this.onMobile = true;
        }
    }

    /**
     * init activation tel
     */
    initPopinNavProPri() {
        if (this.needToDisplayPopin) {
            this.initPopin();
            //this.sessionStoragePop.addSimpleBooleanInSessionStorage();
        } else if ($(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            // if no popin - display following popin on mobile
            this.popin.displayNextPopin();
        }
    }

    /**
     * init activation tel
     */
    initPopin() {
        var data = {};
        var _self = this;
        _self.popin.hide();

        data.headLine = POPIN_PROFILE_DEFAULT_VALUES.TEXT_HEADLINE;
        //data.description = POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_1 + _self.clientName + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_2 + _self.market + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_3;
        data.description = POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_1 + _self.market + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_2 + "<strong>"+ POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_3 + _self.market + "</strong>" + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_4;
        data.hideLink = true;

        _self.popin.updatePopinData(data);
        _self.popin.show();
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/popinNavProPri.js